var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-input',{class:_vm.inputClass,attrs:{"value":_vm.formattedValue,"placeholder":_vm.placeholder,"state":_vm.state,"id":_vm.id,"disabled":_vm.disabled,"type":"text"},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }